export abstract class AudioUsecase {
  abstract get context(): AudioContext;
  abstract get ringtone(): { play: () => void; stop: () => void; playing: () => boolean };
}
